module.exports = __webpack_public_path__ + "img/1.3650a35f.jpg";